import { css } from 'styled-components';
import {
  grid,
  gridUnit,
  BreakpointQueryName,
  SpacingName,
  TypographyName,
  getTypography,
  ThemedFunctor,
} from '@doveit/lego';

export const base: ThemedFunctor = ({
  theme,
}) => css`
  ${grid(theme, { gutter: SpacingName.SMALL })}
`;

export const item: ThemedFunctor = ({
  theme,
  $count,
}) => css`
  border-radius: 6px;

  ${gridUnit(theme, {
    gutter: SpacingName.SMALL,
    size: { MD: 1 / $count },
  })}
`;

export const box: ThemedFunctor = ({
  theme,
}) => css`
  background-color: ${theme.palettes.neutrals.lightest};
  border: 1px solid ${theme.palettes.neutrals.light};
  padding: ${theme.spaceUnits.mobile.SMALL};
  border-radius: 6px;
  height: 100%;
  text-align: center;
  min-height: 7.5rem;
  display: flex;
  flex-direction: column;
  justify-content: center;

  ${theme.breakpoints.up(BreakpointQueryName.MD)} {
    padding: ${theme.spaceUnits.desktop.MEDIUM};
    min-height: auto;
  }
`;

export const value: ThemedFunctor = ({
  theme,
}) => css`
  ${getTypography(theme, TypographyName.H2)}
  color: ${theme.palettes.brand.primary};
  margin-right: 1rem;

  ${theme.breakpoints.up(BreakpointQueryName.MD)} {
    margin-right: 0;
  }
`;

export const label: ThemedFunctor = ({
  theme,
}) => css`
  ${getTypography(theme, TypographyName.BODY)}
`;
